import { call, put, takeLatest } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';
import { shareActions } from '../slices/share.slice';
import {
  addMemorableMoment,
  addToShare,
  deleteMemorableMoment,
  getFanShare,
  getFanShareHistory,
  getMemorableMoments,
  getTeamShare,
  getTeamShareHistory,
  removeShareItem,
} from '../../services/share.service';
import { notificationActions } from '../slices/notification.slice';

function* addToShareSaga({ payload }: any): SagaIterator {
  try {
    yield call(addToShare, payload);
    yield put({ type: shareActions['addToShare/ok'].type });
    yield put({
      type: notificationActions.success.type,
      payload: 'Added to share page',
    });
  } catch (err) {
    yield put({ type: shareActions['addToShare/err'].type });
    yield put({ type: notificationActions.error.type, payload: err });
  }
}

function* addMemorableMomentSaga({ payload }: any): SagaIterator {
  try {
    yield call(addMemorableMoment, payload);
    yield put({ type: shareActions['addMemorableMoment/ok'].type });
    yield put({ type: shareActions.getMemorableMoments.type });
    yield put({
      type: notificationActions.success.type,
      payload: 'Saved to Joy',
    });
  } catch (err) {
    yield put({ type: shareActions['addMemorableMoment/err'].type });
    yield put({ type: notificationActions.error.type, payload: err });
  }
}

function* getMemorableMomentsSaga(): SagaIterator {
  try {
    const result: any = yield call(getMemorableMoments);
    const data = Array.isArray(result) ? result : result?.data;

    console.log('JOY GET RAW RESULT', result);
    console.log('JOY GET RESPONSE', data);

    yield put({
      type: shareActions['getMemorableMoments/ok'].type,
      payload: Array.isArray(data) ? data : [],
    });
  } catch (err) {
    console.log('JOY GET ERROR', err);
    yield put({ type: shareActions['getMemorableMoments/err'].type });
    yield put({ type: notificationActions.error.type, payload: err });
  }
}

function* deleteMemorableMomentSaga({ payload }: any): SagaIterator {
  try {
    yield call(deleteMemorableMoment, payload);
    yield put({
      type: shareActions['deleteMemorableMoment/ok'].type,
      payload,
    });
    yield put({
      type: notificationActions.success.type,
      payload: 'Removed from Joy',
    });
  } catch (err) {
    yield put({ type: shareActions['deleteMemorableMoment/err'].type });
    yield put({ type: notificationActions.error.type, payload: err });
  }
}

function* getTeamShareSaga({ payload }: any): SagaIterator {
  try {
    const result: any = yield call(getTeamShare, payload);
    const data = Array.isArray(result) ? result : result?.data;

    yield put({
      type: shareActions['getTeamShare/ok'].type,
      payload: Array.isArray(data) ? data : [],
    });
  } catch (err) {
    yield put({ type: shareActions['getTeamShare/err'].type });
    yield put({ type: notificationActions.error.type, payload: err });
  }
}

function* getFanShareSaga({ payload }: any): SagaIterator {
  try {
    const result: any = yield call(getFanShare, payload);
    const data = Array.isArray(result) ? result : result?.data;

    yield put({
      type: shareActions['getFanShare/ok'].type,
      payload: Array.isArray(data) ? data : [],
    });
  } catch (err) {
    yield put({ type: shareActions['getFanShare/err'].type });
    yield put({ type: notificationActions.error.type, payload: err });
  }
}

function* getTeamShareHistorySaga(): SagaIterator {
  try {
    const result: any = yield call(getTeamShareHistory);
    const data = result?.data ?? result;

    yield put({
      type: shareActions['getTeamShareHistory/ok'].type,
      payload: data || { currentEvent: null, previousEvents: [] },
    });
  } catch (err) {
    yield put({ type: shareActions['getTeamShareHistory/err'].type });
    yield put({ type: notificationActions.error.type, payload: err });
  }
}

function* getFanShareHistorySaga(): SagaIterator {
  try {
    const result: any = yield call(getFanShareHistory);
    const data = result?.data ?? result;

    yield put({
      type: shareActions['getFanShareHistory/ok'].type,
      payload: data || { currentEvent: null, previousEvents: [] },
    });
  } catch (err) {
    yield put({ type: shareActions['getFanShareHistory/err'].type });
    yield put({ type: notificationActions.error.type, payload: err });
  }
}

function* removeShareItemSaga({ payload }: any): SagaIterator {
  try {
    yield call(removeShareItem, payload);
    yield put({ type: shareActions['removeShareItem/ok'].type });
    yield put({
      type: notificationActions.success.type,
      payload: 'Removed from share page',
    });
  } catch (err) {
    yield put({ type: shareActions['removeShareItem/err'].type });
    yield put({ type: notificationActions.error.type, payload: err });
  }
}

export function* watchShare(): SagaIterator {
  yield takeLatest(shareActions.addToShare.type, addToShareSaga);
  yield takeLatest(shareActions.addMemorableMoment.type, addMemorableMomentSaga);
  yield takeLatest(
    shareActions.getMemorableMoments.type,
    getMemorableMomentsSaga,
  );
  yield takeLatest(
    shareActions.deleteMemorableMoment.type,
    deleteMemorableMomentSaga,
  );
  yield takeLatest(shareActions.getTeamShare.type, getTeamShareSaga);
  yield takeLatest(shareActions.getFanShare.type, getFanShareSaga);
  yield takeLatest(
    shareActions.getTeamShareHistory.type,
    getTeamShareHistorySaga,
  );
  yield takeLatest(
    shareActions.getFanShareHistory.type,
    getFanShareHistorySaga,
  );
  yield takeLatest(shareActions.removeShareItem.type, removeShareItemSaga);
}